import React, { FC, useCallback } from 'react'
import { Grid, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { Modal } from '../../../../components/Modal'
import { adjustCommissionsModal } from '../../../../store/selectors'
import { updateCommissionsRequest } from '../../../../store/actions'

interface CommissionsAdjustConfirmModalProps {
  isOpen: boolean
  modalClose: () => void
  clearAmounts: () => void
  clearCheckedIds: () => void
}

export const CommissionsAdjustConfirmModal: FC<CommissionsAdjustConfirmModalProps> = ({
  isOpen,
  modalClose,
  clearAmounts,
  clearCheckedIds,
}) => {
  const dispatch = useDispatch()
  const { percentage, amount, ids } = useSelector(adjustCommissionsModal)

  const onSubmit = useCallback(() => {
    dispatch(updateCommissionsRequest({ commissions: Object.keys(ids).map(Number), percentage, amount }))
    clearCheckedIds()
    clearAmounts()
  }, [dispatch, clearCheckedIds, clearAmounts, ids, percentage, amount])

  return (
    <Modal title="Confirm changes" submitTitle="Confirm" isOpen={isOpen} modalClose={modalClose} onSubmit={onSubmit}>
      <Grid container spacing={1} minHeight={80}>
        <Grid item xs={12} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
          <Grid item xs={4}>
            <Typography variant={'h5'}>TX ID</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant={'h5'}>Before</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant={'h5'}>Amount</Typography>
          </Grid>
        </Grid>
        {Object.keys(ids).length > 0 &&
          Object.entries(ids).map(([key, value]) => (
            <Grid item xs={12} key={key} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
              <Grid item xs={4}>
                {key}
              </Grid>
              <Grid item xs={4}>
                {value || '-'}
              </Grid>
              <Grid item xs={4}>
                {value && percentage ? value + value * (percentage / 100) : amount}
              </Grid>
            </Grid>
          ))}
      </Grid>
    </Modal>
  )
}
